import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { ContactUsPanel } from '@juvare/contact-management/ui/features/contact-us';
import { Button, DialogActions, DialogContent } from '@mui/material';
import React from 'react';
export function showContactUsModal(t) {
    showCustomDialog({
        maxWidth: 'md',
        content: (close) => (React.createElement(React.Fragment, null,
            React.createElement(DialogContent, null,
                React.createElement(ContactUsPanel, { appName: window.appName, isAnonymous: false, onAfterSubmit: () => close() })),
            React.createElement(DialogActions, null,
                React.createElement(Button, { color: 'primary', "data-test": 'form-dialog-submit-button', onClick: () => close() }, t('accountBadgeSection.accountBadgesTable.cancelButton'))))),
        onEscapeKeyDown: (close) => close(),
    });
}
